<template>

  <div class="pdp-default-v2">
    <h2 class="header">
      <span class="pdpTitle">{{ content.pdpTitle }}</span>
      <button :aria-label="content.pdpClose" class="close-btn" tabindex="0" ref="pdpWindow" @click="closePdp" @keydown.esc="closePdp">
        <img alt="Close" src="/images/icon-close-white.svg"/>
      </button>
    </h2>

    <div ref="toastContent" class="content">
      <div :class="`content-container ${flyerOrientation}`">
        <div class="pdpContainer">
          <div class="productImageContainer">
            <img :src="productImage" class="productImage" alt="ProductImage"/>
          </div>
          <div class="price" tabindex="0">
            <h2>
              <span v-if="pricePrefix && !memberPrice"> {{ pricePrefix }} </span>
              <span v-if="priceQty && !memberPrice && !isXDaySale">{{ priceQty }} /</span>

              <span v-if="memberPrice && memberPricePrefix">{{toTitleCase(memberPricePrefix)}} </span>
              <span v-if="memberPrice && memberPriceQty">{{memberPriceQty}} /</span>
              <span v-if="memberPrice">{{memberPrice}}</span>
              <span v-if="memberPrice && memberPriceUnit"> {{memberPriceUnit}}</span>

              <span v-if="isXDaySale && rowPriceQty">{{rowPriceQty}} / </span>
              <span v-if="isXDaySale && rowPrice"> {{rowPrice}}</span>
              <span v-if="isXDaySale && rowSave"> {{rowSave}}</span>
              <span v-if="memberPrice && rowPriceUnit">{{rowPriceUnit}}</span>
              <span v-if="!memberPrice && salePrice && !isXDaySale"> {{ salePrice }}</span>
              <span v-if="!memberPrice && salePrice && isXDaySale"> {{ rowPriceUnit }}</span>
              <span v-if="!memberPrice && promoUnit && !isXDaySale && salePrice!==''"> {{ promoUnit }}  </span>
              <span v-if="taxSuffix" class="tax">{{taxSuffix}}</span>
              <div>
                <span v-if="(memberPrice||memberSave) && memberSavePrefix"> {{ toTitleCase(memberSavePrefix) }}</span>
                <span v-if="(memberPrice || memberSave)"> {{ memberSave }}</span>
                <span v-if="(memberPrice || memberSave) && memberSaveSuffix"> {{ toTitleCase(memberSaveSuffix) }}</span>
              </div>
              <div v-if="isXDaySale" class="xdaysaledates" v-html="XDaySaleDates"> </div>

              <div class="rowSalePrice" v-if="isXDaySale">
                <span v-if="priceQty">{{priceQty}} /</span>
                <span>{{pricePrefix}} {{salePrice}} {{promoUnit}} </span>
                <span v-if="!salePrice">{{product.savingsEn}} </span>
                <span v-if="language=='en'">REST OF THE WEEK / LE RESTE DE LA SEMAINE</span>
                <span v-else>LE RESTE DE LA SEMAINE / REST OF THE WEEK</span>
              </div>

              <p
                  v-if="product.alternatePrice"
                  class="alternatePrice"
              >{{ product.alternatePrice }}</p>
            </h2>

            <div v-if="product.savingsEn && !product.salePrice && !memberSave && !isXDaySale" class="savings">
              <h2>
                {{ product.savingsPrefix }}
                {{ product.savingsEn }}
                {{ product.savingsSuffix }}
              </h2>
            </div>
          </div>

          <div class="discountPrice" v-if="memberSave && savings">
            {{savingsPrefix}} <span v-if="savings">{{savings}} </span> {{savingsSuffix}}
          </div>

          <div class="discountPrice" v-if="language=='en' && memberPrice">
            {{product.salePricePrefixEn}} <span v-if="priceQty">{{priceQty}} /</span> {{salePrice}}
          </div>

          <div class="discountPrice" v-if="language=='fr' && memberPrice">
            {{product.salePricePrefixFr}} <span v-if="priceQty">{{priceQty}} /</span> {{salePrice}}
          </div>

          <div class="discountPrice">
            {{loyaltyPrefix}} {{loyalty}} {{loyaltySuffix}}
          </div>

          
          <div v-if="regularPrice && regularPrice !== salePrice" class="regularPrice">
						<span class="label">{{content.pdpRegularPrice}} :</span>
            <span>{{regularPrice}}</span>
					</div>

          <div class="productName" v-if="product.productEn">
            {{productName}}
          </div>
          <div class="bodyEn">
            {{bodyEn}}
          </div>

          <!-- <div class="rowSave" v-if="rowSave">
            {{rowSave}}
          </div> -->

          <div class="rowSave" v-if="savings && salePrice!==''">
            {{savingsPrefix}} {{savings}} {{savingsSuffix}}
          </div>

          <div v-if="limitQty" class="limitQty">
            {{limitQty}}
          </div>

          <div class="validity" v-if="!isXDaySale">
            <span><strong>{{ content.pdpValidFrom }}</strong></span>
            <div class="date" v-html="flyerDate"></div>
          </div>

          <p class="disclaimer-content">{{ content.disclaimer }}</p>

          <div class="addtoList-container">
            <button v-if="checkProductInSL(product)"
                    class="shopOptions removeFromList"
                    tabindex="0"
                    @click="handleRemoveFromList(product)"
            >
              {{ content.pdpRemoveFromList }}
            </button>

            <button v-else-if="listEnabled"
                    class="shopOptions pdpAddToList"
                    tabindex="0"
                    @click="handleAddToList(product)"
            >
              {{ content.pdpAddToList }}
            </button>

          </div>

          <div class="pharma-disclaimer-container" v-if="isPharmaProduct && config.pharmaDisclaimer.enabled">
            <div class="en-pharma-disclaimer-container" v-if="showBilingualDisclaimer">
              <h2> {{ content.pharmaDisclaimer.titleEn }} </h2>
              <h3> affiliated to  <span :style="{color: config.pharmaDisclaimer.logoColor}"><img :src="getLogo" alt="logo" /> {{ clientName }}</span> are proud
                to offer you products and advice for your health</h3>
              <strong>{{ content.pharmaDisclaimer.impMsgEn }}</strong>
              <p> {{ content.pharmaDisclaimer.message1En  }} {{clientName}} {{content.pharmaDisclaimer.message2En}}</p>
            </div>

            <div class="fr-pharma-disclaimer-container">
              <h2> {{ content.pharmaDisclaimer.titleFr }} </h2>
              <h3> affiliés à  <span :style="{color: config.pharmaDisclaimer.logoColor}"><img :src="getLogo" alt="logo" /> {{ clientName }}</span> vous offrent des
                produits et des conseils pour votre santé</h3>
              <strong>{{ content.pharmaDisclaimer.imgMsgFr }}</strong>
              <p> {{ content.pharmaDisclaimer.message1Fr  }} {{clientName}} {{content.pharmaDisclaimer.message2Fr}}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {mapActions, mapGetters, mapState} from "vuex";
import moment from "moment";
import featureMixin from "@/mixins/featureMixin";
import router from "@/router";
import pdpProductMixin from "@/features/pdp/PdpProductMixin";
import AppConfig from "@/classes/AppConfig";


export default {

  mixins: [featureMixin, pdpProductMixin],

  data() {
    return {
      toastContent: null,
      ready: false,
      featurePath: 'pdp',
      featureEvents: ['productRegionClick']
    };
  },
  mounted() {
    this.ready = true;
    this.$refs.pdpWindow.focus();
    // console.log(this.$refs.pdpPopup);
    /*if(this.enabled){
            const pdpFocus = this.$refs.pdpPopup;
            pdpFocus.focus();
          }*/

  },
  computed: {
    ...mapGetters(["content", "language","dealId","blockData","isJC"]),
    ...mapGetters("screen", ["flyerOrientation"]),
    ...mapGetters("landingPage", ["currentFlyer"]),
    ...mapState("shoppingList", ["shoppingListV2"]),
    ...mapGetters("pdp", {pdpEnabled: "enabled"}),
    ...mapState("pdp", {showPdp: "isVisible"}),
    ...mapGetters('shoppingList', {listEnabled: 'enabled'}),

    isPharmaProduct(){
      if(this.product?.tags === null) return false;
      return this.product?.tags?.some(txt => txt.toLowerCase() === 'pharma')
    },
    showBilingualDisclaimer(){
      return this.currentFlyer.province === 'NB' || this.currentFlyer.province === 'ON';
    },

    getLogo(){
       return `/icons/favicon/${AppConfig?.AppConf?.title}.ico`
    },
    clientName(){
      return `${AppConfig?.AppConf?.title}`
    },

    isSwipeAndSave() {
      if (this.product === null) return;
      return this.product.tags?.includes('S&S');
    },

    isXDaySale() {
      if (this.product === null) return;
      const date = router.currentRoute.query['timeTravelDate'] ?? moment();
      //subtracting and adding 1 day because isBetween function from momentJS doesn't consider the actual date (same day) that are passed as parameters
      const startDate = moment(this.product.validFromROW).subtract(1, "days")
      const endDate = moment(this.product.validToROW).add(1, "days")
      if ((this.product.validFrom !== this.currentFlyer.startDate) && (this.product.validTo !== this.currentFlyer.endDate) ||
          (this.product.validFromROW !== this.currentFlyer.startDate) && (this.product.validToROW !== this.currentFlyer.endDate)) {
        return moment(date).isBetween(startDate, endDate); 
      } else
        return false
    },

    XDaySaleDates(){
      if (this.product === null) return;
      let startDate, endDate;
      startDate = moment(this.product.validFromROW)
      endDate = moment(this.product.validToROW)

      if (this.language === 'en') {
        return `${moment.utc(startDate).locale(this.language).format('MMMM D, YYYY')} to ${moment.utc(endDate).locale(this.language).format('MMMM D, YYYY')}`
      } else {
        return `${startDate.format('D MMM YYYY').replace('1er', '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')} au ${endDate.format('D MMM YYYY').replace('1er', '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')}`;
      }
    },

    flyerDate() {
      if (this.product === null) return;
      let startDate, endDate;
      /*if (this.isXDaySale) {
        startDate = moment(this.product.validFromROW);
        endDate = moment(this.product.validToROW)
      } else {
        if (this.product.validFrom !== null) {*/
          startDate = moment(this.product.validFrom)
          endDate = moment(this.product.validTo)
      /*  } else {
          startDate = moment(this.product.validFromROW);
          endDate = moment(this.product.validToROW)
        }
      }*/

      if (this.language === 'en') {
        return `${moment.utc(startDate).locale(this.language).format('MMMM D, YYYY')} to ${moment.utc(endDate).locale(this.language).format('MMMM D, YYYY')}`
      } else {
        return `${startDate.format('D MMMM, YYYY').replace('1er', '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')} jusqu'au ${endDate.format('D MMMM, YYYY').replace('1er', '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')}`;
      }

    },


    getSalePrice() {
      if (this.product === null) return
      let price
      const date = router.currentRoute.query['timeTravelDate'] ?? moment();
      //subtracting and adding 1 day because isBetween function from momentJS doesn't consider the actual date (same day)
      const startDate = moment(this.product.validFromROW).subtract(1, "days")
      const endDate = moment(this.product.validToROW).add(1, "days")
      if (this.isSwipeAndSave) {
        if (this.product?.savingsEn) {
          price = this.product.savingsPrefix + ' ' + this.product.savingsEn
          return price
        } else {
          price = this.product.salePrice
        }
      } else if (this.isXDaySale)
        price = this.product?.salePrice
      else if (this.product.rowPrice && moment(date).isBetween(startDate, endDate))
        price = this.product?.rowPrice;
      else
        price = this.product?.rowPrice;

      if (price == null)
        return ''


      else {
        if (this.product?.savingsEn) {
          price = this.product.savingsPrefix + ' ' + this.product.savingsEn
          return price
        } else {
          if (price.trim() !== '') {
            // do nothing to test
          } else {
            price = this.product.salePrice;

          }

        }
      }
      return this.product?.priceSign?.includes('$') ? `${this.product.priceSign}${(price)} ` : `${price}${this.product.priceSign}`;
    },

    getContents() {
      return this.product?.contents
    },

    columnView() {
      return this.flyerOrientation === "vertical";
    },

    enabled() {
      return this.pdpEnabled && this.config.mode === 'internal';
    }

  },

  methods: {
    ...mapActions(["setPdpDisplay", "setCurrentProduct"]),
    ...mapActions("shoppingList", ["setAddToList", "setRemoveFromList", "handleFlyerDate"]),
    ...mapActions("pdp", ["close", "open"]),

    /*onFeatureEvent(event, data) {
      if (this.config.enabled) {
        // console.log('PDP Event:', data.product)
        if (this.config.mode === 'internal' && data.sku !== 'url' && !data.isVideo) {
          this.open(data.product);
        }
      }
    },*/

    closePdp() {
      if (this.ready) {
        this.close();
      }
    },
    toTitleCase(str) {
      return str.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    handleAddToList(product) {
      // console.log("Handle add to list", product)
      const additionalItemFlag = false;
      const version = 'v2'
      const isPharma = this.isPharmaProduct || false;
      const isXdaySale = this.isXDaySale || false;
      const date = this.isXDaySale ? this.XDaySaleDates : this.flyerDate
      this.handleFlyerDate(date)
      this.setAddToList({product, additionalItemFlag, version, isPharma, isXdaySale});
    },

    handleRemoveFromList(product) {
      const version = 'v2'
      this.setRemoveFromList({product, version});
    },

    checkProductInSL(product) {
      let item = this.shoppingListV2.filter(function (e) {
        return e.sku == product.sku;
      });
      if (item.length > 0) return true;
      else return false;
    },

    gotoInstaCart() {
      window.open(this.product.url)
    }
  },

  watch: {
    showPdp(val) {
      if (val) {
        this.$nextTick(() => {
          const detailText = document.querySelector('.content .detail-content')
          if (detailText) {
            detailText.innerHTML = detailText.innerHTML

                .replace(/\*\*/g, '<br>**')
                .replace(/(^|\s)\*(?=\S)/g, '<br>*')
                .replace(/-/g, '&#x2011;')
          }
        })
        setTimeout(() => {
          this.ready = true;
          const pdpFocus = this.$refs.pdpPopup;
          pdpFocus.focus();
        }, 100);
      }
      this.ready = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.modal-wpr {
  position: absolute;
  margin-top: -1px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 20;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-flow: column;

  .modal {
    background-color: var(--secondary-color);
    /*margin-top: 75px;*/
    border: 1px solid #bbbbbb;
    /* overflow: auto;*/
    max-height: calc(100% - 1em);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    display: flex;
    flex-flow: column;
    min-width: 300px;
    max-width: 370px;

    .header {
      background-color: var(--secondary-color);
      color: var(--primary-text-color);
      display: flex;
      justify-content: space-between;
      padding: 10px;

      h2 {
        font-size: 1.3em;
        text-transform: uppercase;
        font-weight: 400;
      }

      .close-btn {
        cursor: pointer;

        &:hover {
          background: none;
          filter: unset;
        }
      }
    }

    .subtitle {
      padding-top: 6px;
      font-size: 12px;
    }

    .content {
      padding: 8px;
      background-color: #fff;
      color: #545454;
      position: relative;
      flex: 1 0 auto;
      overflow-x: hidden;
      font-size:0.9em;
      margin: 10px 10px 17px;
      min-height: 250px;
      max-height: calc(100% - 5em);
      max-width: 350px;

      .content-container {
        text-align: left;
        //width:300px;
      }

      .f-half {
        display: flex;
        column-gap: 1em;

        flex-direction: column;

        > div {
          flex-basis: 100%;
          display: flex;
          flex-flow: column;
        }
      }
    }
  }
}

.pdpTitle {
  font-size:0.9em;
  font-weight: bold;
}

.pdpContainer {
  //margin-left: 10px;
  max-width: calc(100vw - 5em);

  h2 {
    font-size: 18px;

    .xdaysaledates{
      font-size: 16px;
      text-transform: uppercase;
    }

    .rowSalePrice{
      margin:10px 0;
      font-weight: bold;
      color: black;
      font-size:15px;
      text-transform: uppercase;
    }
  }

  .productImageContainer {
    background-color: #fff;
    padding: 5px 0;
    margin-bottom: 10px;
    border: 1.5px solid lightgrey;
    display: flex;
    justify-content: center;
  }

  .productImage {
    // max-height: 60%;
    // max-width: 60%;
    display: flex;
    max-height: 165px;
    max-width: 120px;
  }

  .price {
    display: flex;
    color: #ee3124;
  }

  span.alternatePrice {
    display: inline-block;
  }

  .alternatePrice {
    color: #000;
    font-size: 13px;
    font-weight: normal;
    margin-left: 5px;
  }

  span.tax {
		margin-left: 5px;
	}

  .savings {
    color: #ee3124 !important;
    font-size: 18px;
    margin-top: 5px;
  }

  .regularPrice{
		font-size: 13px;
		font-weight: 900;
		margin-top: 1px;

		.label {
			margin-right: 5px;
		}
	}

  .limit {
    font-weight: 900;
    color: #000;
    font-size: 1.2em;
  }

  .productName{
    font-weight: 900;
    margin-top: 10px;
  }

  .bodyEn{
    white-space: pre-line;
    margin-bottom: 10px;
  }

  .rowSave{
    margin-top: 10px;
    font-weight: 900;
    text-transform: uppercase;
  }

  .limitQty{
    margin-bottom: 10px;
    font-weight: 900;
  }

  .detail {
    margin-top: 10px;
    font-weight: 900;

    .detail-content {
      font-size: 12px;
      font-weight: normal;
      white-space: break-spaces;
    }
  }

  .disclaimer-content {
    font-size: 9px;
    font-weight: normal;
    margin-top: 10px;
    font-style: italic;
  }

  .daysOnly {
    margin-top: 10px;
    font-size: 1.1em;
    font-weight: 900;
  }

  .discountPrice{
    text-transform: uppercase;
    font-weight: bold;
  }

  & .validity {
    margin-top: 10px;
  }
}

button {
  background: transparent;
  // border: 1px solid #ccc;
  text-transform: uppercase;
  font-weight: 600;
  color: #666;
  border-radius: 4px;
  border: none;
}

button.button {
  background: #fff;
  border: 1px solid #ccc;
  text-transform: uppercase;
  font-weight: 600;
  color: #666;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 16px;
}

button.button:hover {
  background: #eee;
  color: #000;
}

.btn {
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 4px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  color: #333;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  cursor: auto;
  pointer-events: none;
}

.addtoList-container {
  display: flex;
}

.shopOptions {
  display: flex;
  flex: 1;
  cursor: pointer;
  border-radius: 5px;
  margin: 10px 0;
  color: #fff;
  padding: 8px;
  justify-content: center;
  font-weight: normal;
  height: 55px;

  &.shopNow {
    background-color: var(--secondary-color);
  }

  &.pdpAddToList {
    background-color: var(--secondary-color);
  }

  &.removeFromList {
    background-color: #EE3124;
  }
}

.pharma-disclaimer-container{
  padding: 5px 5px;
  margin-bottom: 10px;
  border: 1.5px solid lightgrey;
  display: flex;
  flex-direction: column;
  text-align: center;
  overflow-y:auto;
  max-height: 250px;

  h2{
    color: var(--secondary-color);
    font-size:1.5em;
    margin-bottom: 5px;
  }
  h3{
    color: var(--secondary-color);
    font-size: 1em;
    margin-bottom: 5px;

    .logoColor {
      color: #EE3124;
    }

      img{
        width:1.1em;
      }
  }
  p{
    font-size:0.9em;
  }
}

/* width */
::-webkit-scrollbar {
  width: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  //background: #f1f1f1;
  display: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.btn.page {
  width: 100%;
  height: 28px;
  justify-content: flex-start;
  padding-left: 3%;
  margin-bottom: 8px;

  & + .subtitle {
    text-align: left !important;
  }
}

.page-num {
  background-color: var(--primary-color);
  color: var(--primary-text-color);
  border-radius: 4px;
  font-size: 12px;
  padding: 7px;
}

@media only screen and (max-height: 850px) and (min-width: 1024px) {
  .modal-wpr .modal {
    .content {
      .f-half {
        flex-direction: row !important;
      }

      .content-container {
        width: 308px;

      }
    }
  }
}


@media only screen and (max-width: 700px) {
  .modal-wpr .modal {
    .content {
      .content-container {
        //width: 300px;
        .productImage {
          // max-height: 50%;
          // max-width: 50%;
          max-height: 180px;
          max-width: 85px;
        }
      }
    }
  }
}

/* Vertical View Specific */
@media (min-width: 1200px) {
  .modal-wpr .modal.vertical .content .feature.navigation {

    h4,
    .subtitle {
      text-align: left;
      width: 100%;
    }

    .subtitle + .subtitle {
      margin-top: 1em;
    }
  }
  .content-container {
    width: 308px;
  }
}
</style>